var $ = require("jquery");
import Swal from 'sweetalert2';
const InitSwal = require('sweetalert2');
const axios = require('axios');
//Alert Function
function notification(message, status, progres = true) {

    const Toast = InitSwal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: progres,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', InitSwal.stopTimer)
            toast.addEventListener('mouseleave', InitSwal.resumeTimer)
        }
    })

    Toast.fire({
        icon: status,
        title: message
    })
}

//TCC Verification
$("#tcc-verification").click(function () {
    $("#data-display").hide()
    if ($("#ref").val() == '') {
        return;
    }

    
    $(this).html('Searching...')
    $('#display-report').html("")
    var ref = $("#ref").val();
    axios.get("/api/tcc/ontime-verification/"+ref )
    .then(function (response) {
        let data = response.data
        if (data.status) {
            $("#data-display").show()  
            // Select the element by class and ID
            var element = document.querySelector('.collapsed#accordion1-card-head-locyysyh')

            if(element){
                element.click(); 
            }
            
            $('#ref_id').val(data.data.ref)
            $('#tin').val(data.data.tin)         
            $('#name').val(data.data.title +' '+data.data.name)
            $('#expiring').val(data.data.expiring)
            $('#source').val(data.data.source)
            $('#date_issued').val(data.data.date_issued)
            $('#tcc-data').html(response.data.table)
            $("#tcc-verification").html('Verify TCC')
            return notification("TCC Found", "success", true);
        }
        $("#tcc-verification").html('Verify TCC')
        $('#display-report').html("TCC Not Found")
        return;
    })
    .catch(function (error) {
        return notification(error, "warning", false);
        $("#tcc-verification").html('Verify TCC')
    });
})

$(".download-data").click(function () {
    var id = $("#ref").val();
    var url = '';
    url = '/api/tcc/ontime-verification-print/'+id
    var data = {
        id: id
    }
    axios.get(url)
    .then(function (response) {

        let data = response.data
        if (data.status) {
           
            var printWindow = window.open('', '', 'height=400,width=800');
            printWindow.document.write(data.data);
            printWindow.document.close();
            printWindow.print();

            return;
        }
        return notification(data.message, "warning", false);
        
    })
    .catch(function (error) {
        return notification(error, "warning", false);
        
    });
})



